<script setup>
import PrintLog from '@/components/Doctrine/includes/PrintLog.vue'

defineProps({
  value: [String, Object, Boolean, null],
  field: String,
})

</script>

<template>
  <div>
    <template v-if="typeof value === 'object' && value !== null">
      <div class="mb-3">
        <p class="mb-0">
          <b>{{field}}</b>:
          <span v-if="Object.keys(value).length === 0">[ ]</span>
        </p>
        <p v-for="(item, idx) in value" :key="idx" class="mb-0 ps-3">
          <PrintLog
            :value="item"
            :field="idx"
          />
        </p>
      </div>
    </template>
    <template v-else>
      <p class="mb-0">
        <b>{{field}}</b>:

        <span v-if="value === null"> Null </span>
        <span v-else> {{ value }} </span>
      </p>
    </template>
  </div>
</template>
